///<reference path="../typings/index.d.ts" />
///<reference path="../node_modules/immutable/dist/immutable.d.ts" />

// Modifies the browser environment to support ES5/ES6 features.
import 'babel-polyfill'

import * as $_ from 'jquery';

declare var window:Window & {jQuery: JQueryStatic, $: JQueryStatic}

// jQuery detects that it's inside Webpack and doesn't assign to
// global $/jQuery, but some plugins need it there while they load :\
//noinspection JSUnusedAssignment
window.jQuery = window.$ = $_

// Not a CommonJS or AMD module, but attaches to global $ so must be loaded before we do $.noConflict()
import 'drmonty-chosen';
import 'drmonty-chosen/css/chosen.css';
import 'jquery-ui';
import 'jquery-ui/dialog';
import 'jquery-ui/datepicker';
import 'jquery-pttimeselect';
import 'jquery-validation';
import 'jquery-caret';
import 'block-ui'

//i do this instead of just using an import above, so that this will be lowest priority
//we need some kind of jqueryui theming
if(!window.hasOwnProperty("dont_define_jqueryui")) {
	const css = document.createElement('link')
	css.setAttribute('rel', 'alternative stylesheet')
	css.setAttribute('type', 'text/css')
	css.title = "jquery-ui-defaults"
	css.href = '/sb/static/lib/themes/base/minified/jquery-ui.min.css'
	document.head.insertBefore(css, document.head.firstChild)
}

$_.noConflict(true);

import * as analytics_ from './analytics/analytics'
import * as contacts_ from './contacts/contacts'
import * as common_ from './common/common'
import * as paymentgateway_ from './paymentgateway/paymentgateway'
import * as orders2_ from './orders2/orders2'
import * as community2_ from './community2/community2'
import * as membership3_ from './membership3/membership3'
import * as events2_ from './events2/events2'
import * as compliancetracker_ from './compliancetracker/compliancetracker'
import * as news2_ from './news2/news2'
import * as knowledge2_ from './knowledge2/knowledge2'
import * as spareFields_ from './components/spare fields/spare fields'
import * as memory_ from './memory/memory'
import * as wentworthadvantage_ from './3rd party integration/wentworthadvantage/wentworthadvantage'
import * as swfuploader_ from './lib/swfuploader/swfuploader'
import * as modal from './legacy/modal'
import * as FormButtons from './legacy/form-buttons'
import * as SearchDirectory from './searchdirectory/searchdirectory'
import {MulticheckboxCallJs} from "./legacy/html-input-multi-checkbox";
import * as subscriptionmanager_ from './subscriptionmanager/subscriptionmanager'
import * as emailmanager_ from './emailmanager/emailmanager'
import * as communications_ from './communications/communications'
import * as recaptcha_ from './lib/recaptcha'
import * as controlcentre_ from './controlcentre'

namespace ivt {
	export namespace ao {
		export const analytics = analytics_
		export const contacts = contacts_
		export const common = common_
		export const community2 = community2_
		export const knowledge2 = knowledge2_
		export const memory = memory_
		export const spareFields = spareFields_
		export const membership3 = membership3_
		export const events2 = events2_
		export const news2 = news2_
		export const compliancetracker = compliancetracker_
		export const paymentgateway = paymentgateway_
		export const orders2 = orders2_
		export const swfuploader = swfuploader_.swfuploadercalljs
		export const wentworthadvantage = wentworthadvantage_
		export const legacy = {modal, html: {inputMultiCheckbox: MulticheckboxCallJs}, form_buttons: FormButtons.form_buttons, close: () => self.close()}
		export const searchdirectory = SearchDirectory
		export const subscriptionmanager = subscriptionmanager_
		export const emailmanager = emailmanager_
		export const communications = communications_
		export const recaptcha = recaptcha_
		export const controlcentre = controlcentre_
	}
	export var jQuery = $_;
}

// Grab the "ivt" namespace and merge it into the window, since there is no built-in way
// in TypeScript to create a global variable from within a module. :(
//noinspection JSUnusedAssignment
$_.extend(true, window, {ivt})




// WEBPACK FOOTER //
// ./src/main.ts